import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { AnalyticsList, AnalyticsService } from '../../../shared/services/analytics.service';

@Component({
    selector: 'app-block-products',
    templateUrl: './block-products.component.html',
    styleUrls: ['./block-products.component.scss']
})
export class BlockProductsComponent implements OnChanges {
    @Input() header: string;
    @Input() layout: 'large-first'|'large-last' = 'large-first';
    @Input() products: any[] = [];

    /// This block as a GA4 product list, named after its header.
    list: AnalyticsList = AnalyticsService.listFor(null);

    get large(): any
    {
        if (this.layout === 'large-first' && this.products.length > 0) {
            return this.products[0];
        }
        else if (this.layout === 'large-last' && this.products.length > 6)
        {
            return this.products[6];
        }
        return null;
    }

    get smalls(): any[]
    {
        if (this.layout === 'large-first')
        {
            return this.products.slice(1, 7);
        } else  {
            return this.products.slice(0, 6);
        }
    }

    constructor(private analytics: AnalyticsService) { }

    ngOnChanges(changes: SimpleChanges): void {
        if ('header' in changes) {
            this.list = this.analytics.listNamed(this.header);
        }

        if ('products' in changes) {
            this.analytics.viewItemList(this.products, this.list);
        }
    }
}
